import { render, staticRenderFns } from "./Jurisdiction.vue?vue&type=template&id=b90e15bc"
import script from "./Jurisdiction.vue?vue&type=script&lang=ts"
export * from "./Jurisdiction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports